import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, User } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const blogPost = {
  title: 'Tips for Building a Kid-Friendly Martial Arts Studio at Home',
  date: 'May 13th, 2020',
  author: 'Master Joe',
  content: `
    <h2>The Benefits of Martial Arts for Kids</h2>
    <p>Setting up a home dojo might seem like a lot of work, but being able to practice martial arts at home will benefit your children in several ways.</p>
    <ul>
      <li>Kids need at least an hour of moderate-to-vigorous exercise every single day. Martial arts training is an excellent way to help your kids meet these activity guidelines, especially if you can't go outside.</li>
      <li>Learning new skills and progressing through martial arts training is a great way to build confidence and teach kids about perseverance.</li>
      <li>Although the martial arts involve fighting and combat techniques, the practice actually promotes peaceful conflict resolution over violence.</li>
    </ul>

    <h2>Making Space in Your Home for a Studio</h2>
    <p>Depending on the type of martial arts your kids will be practicing at home, you might need quite a lot of space. Basements work really well for this purpose!</p>
    <ul>
      <li>Find out how much it will cost to remodel your basement into a home gym area or martial arts studio.</li>
      <li>Declutter and clean out your basement so your kids have room to practice safely.</li>
      <li>Prevent your martial arts studio from hurting your home value by designing it as a multi-purpose room that future buyers could use for something else.</li>
    </ul>

    <h2>At-Home Martial Arts Gear for Kids</h2>
    <p>While kids don't need much equipment to practice martial arts at home, a few pieces of gear can help them get the most out of their training sessions.</p>
    <ul>
      <li>Protective gear like helmets and mouthguards will keep your kids safe while they're sparring.</li>
      <li>Boxing gloves are an important element of learning gear that will keep your kids safe when they're throwing punches at a dummy or heavy bag.</li>
      <li>If you want to get involved in your kids' training sessions, purchase some foam blockers and targets so they can practice their timing and accuracy.</li>
    </ul>

    <p>Don't let your kids miss out on the benefits of martial arts training during the coronavirus lockdown. It's easy to set up a studio in your own home, as long as you have the space for it. With a couple pieces of safety gear and training equipment, you'll be ready to start training through drills with your kids—you might even learn a few techniques yourself!</p>
  `
};
export function BlogPost() {
  return <article className="py-16 px-4 bg-white" data-id="element-306">
      <div className="max-w-4xl mx-auto" data-id="element-307">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-308">
          {/* Post Meta */}
          <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mb-6" data-id="element-309">
            <div className="flex items-center gap-2" data-id="element-310">
              <Calendar className="w-4 h-4" data-id="element-311" />
              <span data-id="element-312">{blogPost.date}</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-313">
              <User className="w-4 h-4" data-id="element-314" />
              <span data-id="element-315">{blogPost.author}</span>
            </div>
          </div>

          {/* Post Title */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#0f1f3d] mb-8 leading-tight" data-id="element-316">
            {blogPost.title}
          </h1>

          {/* Post Content */}
          <div className="prose prose-lg max-w-none" dangerouslySetInnerHTML={{
          __html: blogPost.content
        }} style={{
          lineHeight: '1.8'
        }} data-id="element-317" />

          <style data-id="element-318">{`
            .prose h2 {
              font-size: 1.75rem;
              font-weight: 800;
              color: #0f1f3d;
              margin-top: 2.5rem;
              margin-bottom: 1.25rem;
            }
            .prose p {
              color: #4b5563;
              margin-bottom: 1.5rem;
              line-height: 1.8;
            }
            .prose ul {
              list-style: none;
              padding-left: 0;
              margin-bottom: 2rem;
            }
            .prose ul li {
              position: relative;
              padding-left: 2rem;
              margin-bottom: 1rem;
              color: #4b5563;
              line-height: 1.8;
            }
            .prose ul li:before {
              content: "•";
              position: absolute;
              left: 0.5rem;
              color: #dc2626;
              font-weight: bold;
              font-size: 1.5rem;
            }
          `}</style>
        </motion.div>
      </div>
    </article>;
}